(function () {
  if (window.__tdCardFitBadgeInitialized) return;
  window.__tdCardFitBadgeInitialized = true;

  function updateCard(wrapper) {
    if (!wrapper || !window.TdYmeFitment || !window.TdVehicleStorage) return;

    const badges = wrapper.querySelectorAll('[data-td-card-vehicle-fit-badge]');
    const vehicle = window.TdVehicleStorage.getSelectedVehicle();
    const hasVehicle = Boolean(vehicle?.make);
    const fits = hasVehicle && window.TdYmeFitment.productMatchesVehicle(wrapper, vehicle);

    badges.forEach((badge) => {
      badge.hidden = !fits;
    });
  }

  function checkAll() {
    document.querySelectorAll('[data-td-card-vehicle-fit]').forEach(updateCard);
  }

  function initObserver() {
    if (window.__tdCardFitBadgeObserver) return;

    window.__tdCardFitBadgeObserver = new MutationObserver((mutations) => {
      const hasNewCards = mutations.some((mutation) =>
        [...mutation.addedNodes].some(
          (node) =>
            node.nodeType === 1 &&
            (node.matches?.('[data-td-card-vehicle-fit]') ||
              node.querySelector?.('[data-td-card-vehicle-fit]'))
        )
      );

      if (hasNewCards) checkAll();
    });

    window.__tdCardFitBadgeObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      checkAll();
      initObserver();
    });
  } else {
    checkAll();
    initObserver();
  }

  window.addEventListener('td:vehicle-storage-change', checkAll);
  window.addEventListener('storage', (event) => {
    if (event.key === window.TdVehicleStorage?.STORAGE_KEY) {
      checkAll();
    }
  });

  window.TdCardVehicleFitBadge = { checkAll };
})();
